import {
  Components, Splide,
} from '@splidejs/splide'
import forEach from 'lodash/forEach'

// Purpose of this extention is to add class on each slider
// when mouse is over one of them and remove it when mouse cursor leaves
export const IsOverStyleExtension = (splide: Splide, components: Components) => {
  const { track } = components.Elements

  let thumbnails

  const mouseEnter = (event) => {
    splide.emit('isOver', event.target.index)
    event.target.classList.add('is-over')
  }

  const mouseLeave = (event) => {
    event.target.classList.remove('is-over')
  }

  const mount = () => {
    thumbnails = track.getElementsByClassName('splide__slide')
    forEach(thumbnails, (elm, index) => {
      // eslint-disable-next-line no-param-reassign
      (elm as any).index = index
      elm.addEventListener('mouseenter', mouseEnter)
      elm.addEventListener('mouseleave', mouseLeave)
    })
  }

  const destroy = () => {
    forEach(thumbnails, (elm) => {
      elm.removeEventListener('mouseenter', mouseEnter)
      elm.removeEventListener('mouseleave', mouseLeave)
    })
  }

  return {
    destroy,
    mount,
  }
}
